import axios from "axios";

let instance = axios.create({
  baseURL: process.env.VUE_APP_SERVICE_BASEURL
    ? process.env.VUE_APP_SERVICE_BASEURL
    : "http://localhost:3000"
});

instance.interceptors.request.use(
  function(config) {
    let token = localStorage.getItem("token") || null;
    console.log(token);
    if (token) {
      config.url = `${config.url}?token=${token}`;
    }
    return config;
  },
  function(error) {
    console.log("request interceptor", error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      localStorage.clear();
    }
    return Promise.reject(error);
  }
);

export default instance;
